// noinspection JSXUnresolvedComponent
import DelegateStructTree from "./DelegateStructTree/DelegateStructTree";
import DelegateEmployeesDropdown from "./DelegateEmployeesDropdown/DelegateEmployeesDropdown";
import { validationRules } from "./validation.rules";

import Header from "../../../../../layout/Header/Header";
import Footer from "../../../../../layout/Footer/Footer";
import Breadcrumbs from "../../../../../common/Breadcrumbs/Breadcrumbs";
import IC from "../../../../../common/compositions/InputComposition/IC";

import SearchDropdown from "../../../../../common/compositions/InputComposition/dropdown.types/SearchDropdown/SearchDropdown";


import InputCompositionContext from "../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import FrontendFormValidationService from "../../../../../../frontend.services/FrontendFormValidation.service";

import OkButton from "../../../../../common/Button/OKButton/OKButton";

import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";

import {
    clearErrorNotificationContentAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearErrorNotificationContent.action";
import {
    getAvailableRequestsThunkAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getAvailableRequestsForDeledation";

import {
    getAvailableEmployeesRequestsDelegationThunkAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getAvailableEmployeesRequestsDelegation.thunk.action";
import {
    sendRequestsDelegation,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/sendRequestsDelegation.thunk.action";

import {
    clearAvailableEmployeesDelegationAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearAvailableEmployeesDelegation.action";
import {
    validateRequestsDelegation,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/validateRequestsDelegation.thunk.action";
import SimpleDropdown
    from "../../../../../common/compositions/InputComposition/dropdown.types/SimpleDropdown/SimpleDropdown";
import SimpleItemForDropDown from "../SimpleItemForDropDown/SimpleItemForDropDown";

import {
    getEligibleDelegateStructsThunkAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getEligibleDelegateStructs.thunk.action";
import {
    getEligibleDelegateStructEmployeesThunkAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getEligibleDelegateStructEmployees.thunk.action";
import {
    clearEligibleDelegateStructsAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/clearEligibleDelegateStructs.action";
import {
    clearEligibleDelegateStructEmployeesAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/clearEligibleDelegateStructEmployees.action";

import NotificationWindowRequests from "../../../../../common/NotificationWindowRequests/NotificationWindowRequests";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import moment from "moment";
import "./AuthorityRequestDelegation.scss";
import "../../ResponsibilitiesDelegation/Delegation.modal.scss";

const AuthorityRequestDelegation = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // const availableSubstitutionTypes = useSelector(state => state.myDivision.availableSubstitutionTypes);
    const availableRequestTypes = useSelector(state => state.myDivision.availableRequestTypes);
    const availableEmployees = useSelector(state => state.myDivision.availableEmployees);
    const errorNotificationContent = useSelector(state => state.myDivision.errorNotificationContent);
    const eligibleDelegateStructs = useSelector(state => state.myDivision.eligibleDelegateStructs);
    const eligibleDelegateStructEmployees = useSelector(state => state.myDivision.eligibleDelegateStructEmployees);
    const eligibleDelegateStructEmployeesLimitExceeded = useSelector(
        state => state.myDivision.eligibleDelegateStructEmployeesLimitExceeded,
    );

    const [delegationState, setDelegationState] = useState({
        rules: {
            "delegatePid": ["notEmpty"],
            "from": ["notEmpty", "earlierThan"],
            "to": ["notEmpty"],
        },
    });
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [notification, setNotification] = useState(false);

    const [notificationWindow, setNotificationWindow] = useState(false);
    const [modalWindowKP, setModalWindowKP] = useState(null);

    const [candidateMode, setCandidateMode] = useState("subordinates");
    const [selectedStruct, setSelectedStruct] = useState(null);
    const [structsLoading, setStructsLoading] = useState(false);
    const [structsLoadError, setStructsLoadError] = useState(false);
    const [employeesLoading, setEmployeesLoading] = useState(false);
    const [employeesLoadError, setEmployeesLoadError] = useState(false);
    const [limitNoticeDismissed, setLimitNoticeDismissed] = useState(false);

    const context = [delegationState, setDelegationState, isError, setIsError];

    function resetSelectedDelegate() {
        setDelegationState((prev) => {
            const temp = { ...prev };
            delete temp.delegatePid;
            return temp;
        });
    }

    function loadStructsHandler() {
        if (structsLoading) return;
        dispatch(getEligibleDelegateStructsThunkAction({
            setIsLoading: setStructsLoading,
            setLoadError: setStructsLoadError,
        }));
    }

    function loadStructEmployeesHandler(structId) {
        if (employeesLoading) return;
        dispatch(getEligibleDelegateStructEmployeesThunkAction(structId, {
            setIsLoading: setEmployeesLoading,
            setLoadError: setEmployeesLoadError,
        }));
    }

    function candidateModeHandler(mode) {
        if (mode === candidateMode || structsLoading || employeesLoading) return;
        setCandidateMode(mode);
        resetSelectedDelegate();
        if (mode === "structs" && !eligibleDelegateStructs) {
            loadStructsHandler();
        }
    }

    function selectStructHandler(item) {
        if (employeesLoading) return;
        setSelectedStruct({ id: item.id, name: item.name });
        dispatch(clearEligibleDelegateStructEmployeesAction());
        resetSelectedDelegate();
        setLimitNoticeDismissed(false);
        loadStructEmployeesHandler(item.id);
    }

    function closeLimitNoticeHandler() {
        setLimitNoticeDismissed(true);
    }
    function backButtonHandler () {
        navigate("/divisions/structure/request-delegation");
    }

    function submitHandler () {
        const validation = new FrontendFormValidationService(delegationState, isError, setIsError, delegationState.rules);
        if (validation.validate()) {
            dispatch(validateRequestsDelegation({
                modalWindowKP,
                setModalWindowKP,
                delegationState,
                setIsLoading, setModalSuccess, setNotification,
            }));
        }
    }

    function closeNotificationHandler () {
        dispatch(clearErrorNotificationContentAction());
        setNotification(false);
    }

    // function selectDropdownForArray(event, element, stateProperty) {
    //
    //
    // }

    useEffect(() => {
        dispatch(getAvailableEmployeesRequestsDelegationThunkAction());
        // dispatch(getAvailableEmployeesDelegationThunkAction());
        dispatch(getAvailableRequestsThunkAction());
        return ()=>{
            dispatch(clearAvailableEmployeesDelegationAction());
            dispatch(clearEligibleDelegateStructsAction());
            dispatch(clearEligibleDelegateStructEmployeesAction());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //
    // }, [errorNotificationContent]);


    useEffect(() => {
        if (modalWindowKP) { //&& !requestStatus.isSuccess
            // console.log("useeffect -------->>>>>>>", requestStatus);
            setNotificationWindow(true);

        }
    }, [modalWindowKP]);
    return (
        <>
            <Header />
            <Breadcrumbs />
            <main
                className={"delegation-transfer"}
                style={{minHeight: "35vh", width: "1160px", margin: "0 auto", position: "relative"}}>

                <h3 className={"sub-header"} style={{alignSelf:"flex-start", marginBottom: "44px"}}>
                    Делегирование полномочий
                </h3>
                <div  style={{ display: "flex", flexDirection: "column", gap: "30px", position: "absolute" }}>
                    {modalWindowKP &&
                    modalWindowKP.length ?
                        modalWindowKP.map((worker, index) => {
                            return (
                                <>
                                    <NotificationWindowRequests
                                        pixels={(index)* 100}
                                        notificationWindowStatus={worker}
                                        setNotificationWindowStatus={setModalWindowKP}
                                        notificationWindowStyle={notificationWindow}
                                        blockingMessages={true}
                                    />
                                </>
                            );


                        }) : null
                    }
                </div>
                {/*<IC field={"delegatorPid"} require>*/}
                {/*    <IC.Label value={"Виды заявок к делегированию прав"} />*/}
                {/*    <IC.Input />*/}
                {/*    /!*<IC.Error />*!/*/}
                {/*    <IC.Dropdown>*/}
                {/*<DropdownMenuTest listOfOptions={availableRequestTypes}/>*/}
                {/*    </IC.Dropdown>*/}
                {/*    <IC.Description*/}
                {/*        value={"В одной заявке вы можете делегировать свои полномочия только на одного работника."}/>*/}
                {/*</IC>*/}
                {/*<DropdownMenuWithCheckbox*/}
                {/*    // currentRequest={currentRequest}*/}
                {/*    styleName={"dimissial-motives"}*/}
                {/*    label={<>Виды заявок к делегированию прав <span className="required_text"> *</span></>}*/}
                {/*    // listOfOptions={availableRequestTypes}*/}
                {/*    stateProperty={"applicationsTypesId"}*/}
                {/*    // selectOptionClick={selectDropdownForArray}*/}
                {/*    isArr={true}*/}
                {/*    option={"applicationsTypesId"}*/}
                {/*/>*/}
                {/*{*/}
                {/*    requests.length > 0 ?*/}
                        <InputCompositionContext.Provider value={context}>

                            <IC field={"applicationsTypesId"} require>
                                <IC.Label value={"Виды заявок к делегированию прав"} />
                                <IC.Input />
                                {/*<IC.Error />*/}
                                <IC.Dropdown>
                                    <SimpleDropdown
                                        delegation={true}
                                        field={"applicationsTypesId"}
                                        items={
                                            availableRequestTypes &&
                                            availableRequestTypes.length
                                                ? availableRequestTypes
                                                :
                                                []
                                        }
                                    >
                                        <SimpleItemForDropDown array={true} field={"applicationsTypes"} property={"name"} />
                                    </SimpleDropdown>
                            {/*<DropdownMenuTest listOfOptions={availableRequestTypes}/>*/}
                                </IC.Dropdown>
                                <IC.Description
                                    value={"В одной заявке вы можете делегировать свои полномочия только на одного работника."}/>
                            </IC>
                            <div style={{background: "rgba(249, 249, 249, 1)", width: "667px", padding: "32px 40px" }}>
                                <div className={"delegation-transfer__candidate-mode"}>
                                    <div
                                        onClick={() => candidateModeHandler("subordinates")}
                                        className={
                                            candidateMode === "subordinates"
                                                ? "delegation-transfer__candidate-mode__item-active"
                                                : "delegation-transfer__candidate-mode__item"
                                        }
                                    >
                                        Подчиненные
                                    </div>
                                    <div
                                        onClick={() => candidateModeHandler("structs")}
                                        className={
                                            candidateMode === "structs"
                                                ? "delegation-transfer__candidate-mode__item-active"
                                                : "delegation-transfer__candidate-mode__item"
                                        }
                                    >
                                        Структура подразделений
                                    </div>
                                </div>

                                {
                                    candidateMode === "structs" &&
                                    <>
                                        <div style={{ fontSize: "12px", lineHeight: "19px", marginTop: "15px" }}>
                                            Подразделение
                                        </div>
                                        <DelegateStructTree
                                            structs={eligibleDelegateStructs}
                                            isLoading={structsLoading}
                                            loadError={structsLoadError}
                                            onRetry={loadStructsHandler}
                                            selectedId={selectedStruct?.id}
                                            selectedName={selectedStruct?.name}
                                            onSelect={selectStructHandler}
                                        />
                                    </>
                                }

                                <div style={{ position: "relative" }}>
                                    <IC key={candidateMode === "structs" ? `structs-${selectedStruct?.id || ""}` : "subordinates"} field={"delegatePid"} require>
                                        <IC.Label value={"ФИО работника, кому делегированы права"} />
                                        <IC.Input />
                                        <IC.Error />
                                        <IC.Dropdown>
                                            {
                                                candidateMode === "subordinates"
                                                    ? <SearchDropdown
                                                        message={"Нет доступных сотрудников для делегирования"}
                                                        items={availableEmployees}/>
                                                    : <DelegateEmployeesDropdown
                                                        message={
                                                            selectedStruct
                                                                ? "В подразделении нет сотрудников"
                                                                : "Сначала выберите подразделение"
                                                        }
                                                        items={selectedStruct ? eligibleDelegateStructEmployees : []}
                                                        isLoading={employeesLoading}
                                                        loadError={employeesLoadError}
                                                        onRetry={() => selectedStruct && loadStructEmployeesHandler(selectedStruct.id)}
                                                    />
                                            }
                                        </IC.Dropdown>
                                    </IC>

                                    {
                                        candidateMode === "structs" &&
                                        eligibleDelegateStructEmployeesLimitExceeded &&
                                        !limitNoticeDismissed &&
                                        <div className={"delegation-transfer__notification delegation-transfer__notification--structs"}>
                                            <div
                                                onClick={closeLimitNoticeHandler}
                                                className={"delegation-transfer__notification__cross"}
                                            ></div>
                                            <div>
                                                <p>
                                                    Сотрудников в выбранном подразделении слишком много.
                                                    Если в представленном списке нет нужного работника,
                                                    необходимо выбрать подразделение по иерархии ниже.
                                                </p>
                                            </div>
                                        </div>
                                    }
                                </div>


                                <div style={{display:"flex", gap: "30px"}}>

                                    <IC field={"from"}
                                        customStyle={"datepicker"}
                                        require
                                    >
                                        <IC.Label value={"Дата начала делегирования"} />
                                        <IC.DatepickerSelect
                                            minDate={new Date()}
                                            maxDate={delegationState.to ? new Date(delegationState.to) : null}
                                        />
                                        <IC.Error />

                                    </IC>

                                    <IC field={"to"}>
                                        <IC.Label value={"Дата окончания делегирования"} />
                                        <IC.DatepickerSelect
                                            delegation={true}
                                            minDate={delegationState.from ? new Date(delegationState.from) : new Date()}
                                            checkbox={true}

                                        />
                                        <IC.Description
                                            value={"Снимите отметку в случае бессрочного делегирования"}/>

                                        {/*<IC.Error />*/}
                                    </IC>
                                </div>
                            </div>

                        </InputCompositionContext.Provider>


                <div style={{width: "1160px", margin: "60px auto", display: "flex", justifyContent: "space-between"}}>
                    <OkButton title={"назад"} handler={backButtonHandler}/>
                    {
                        delegationState.applicationsTypesId?.length ?
                            <OkButton onValidation={isLoading && delegationState.applicationsTypesId?.length} title={"передать заявку"} handler={submitHandler}/>
                            : null
                    }
                </div>

                {
                    notification &&
                    errorNotificationContent &&
                    errorNotificationContent.length
                        ? <div className={"delegation-transfer__notification"}>
                            <div onClick={closeNotificationHandler} className={"delegation-transfer__notification__cross"}></div>
                            {errorNotificationContent.map((e, i) => {
                                return (<div key={i}><p>{e}</p> <br/></div>);
                            })}
                        </div>
                        : null
                }

            </main>
            <Footer />
            {/*TODO ADD MODAL VIEW COMPONENT*/}
            <ModalBanOverlay shown={modalSuccess}>
                <div className={"delegation-modal-status"}>
                    <div className={"delegation-modal-status__header sub-header"}>Делегирование установлено</div>
                    <div className={"delegation-modal-status__content"}>для
                        <span className={"delegation-modal-status__content__highlight"}>{" "}
                            {
                                [...(availableEmployees || []), ...(eligibleDelegateStructEmployees || [])]
                                    .find(e => e.pid === delegationState.delegatePid)?.fullName
                            }
                        </span>{" "}
                        <br/>
                        {
                            delegationState &&
                            delegationState.to
                                ? ( <div>
                                    в период
                                    с <span className={"delegation-modal-status__content__highlight"}>
                                        {moment(delegationState.from).format("DD.MM.YYYY")}
                                    </span>
                                    {" "}
                                    по <span className={"delegation-modal-status__content__highlight"}>
                                        {moment(delegationState.to).format("DD.MM.YYYY")}
                                    </span>
                                </div>)
                                : `в период с ${moment(delegationState.from).format("DD.MM.YYYY")}`

                        }
                    </div>
                    <div className={"delegation-modal-status__buttons"}>
                        <OkButton title={"ок"} handler={backButtonHandler} />
                    </div>
                </div>
            </ModalBanOverlay>
        </>
    );
};

export default AuthorityRequestDelegation;

// TODO GET RID FROM UPPER LEVEL STATE
